/* ============================================================================
   PRESSROOM — NEWSLETTER davranisi (FAZ 2 Parti 3, spec 3.10)
   <pressroom-newsletter> web component.

   Shopify {% form 'customer' %} klasik POST'tur: gonderince sayfa yeniden
   yuklenir ve success durumunda damga (form.posted_successfully?) sunucudan
   render edilir. JS yalnizca his katmani:
   - Submit aninda buton "printing" durumu + ink-bleed kisa puls (gezinmeden
     once gorunur jest). Buton genisligi sabit (CLS yok).
   - Success damgasi DOM'da ise: squeegee-wipe'i bastan oynat (is-wiped'i
     kaldir -> reflow -> ekle), "basildi" hissi.

   reduced-motion: hicbir gelistirme — sunucu durumu aninda gorunur, puls yok.
   Hardcoded yok: bleed suresi --d-base token'dan.
   ============================================================================ */
(function () {
  'use strict';

  if (!('customElements' in window)) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readToken(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }
  function toMs(token, fallbackMs) {
    if (!token) return fallbackMs;
    if (token.indexOf('ms') !== -1) return parseFloat(token);
    if (token.indexOf('s') !== -1) return parseFloat(token) * 1000;
    var n = parseFloat(token);
    return isNaN(n) ? fallbackMs : n;
  }

  customElements.define('pressroom-newsletter', class extends HTMLElement {
    connectedCallback() {
      this._form = this.querySelector('[data-pr-news-form]');
      this._submit = this.querySelector('[data-pr-news-submit]');
      this._success = this.querySelector('[data-pr-news-success]');

      // reduced-motion: durumlar zaten son halinde; gelistirme kurma.
      if (REDUCED) return;

      // Success damgasi DOM'daysa squeegee-wipe'i bastan oynat.
      if (this._success) this._replayStamp(this._success);

      // Submit puls — gercek POST oncesi kisa jest.
      if (this._form && this._submit) {
        this._onSubmit = this._onSubmit.bind(this);
        this._form.addEventListener('submit', this._onSubmit);
      }
    }

    disconnectedCallback() {
      if (this._form && this._onSubmit) {
        this._form.removeEventListener('submit', this._onSubmit);
      }
    }

    _onSubmit() {
      // Native gonderimi engelleme — sadece gorsel jest ekle (gezinme devam eder).
      this._submit.setAttribute('data-pr-state', 'printing');
      this._submit.classList.add('is-bleeding'); // pr-ink-bleed primitive pulsu
    }

    _replayStamp(el) {
      // Markup zaten .is-wiped tasiyor (server render); bastan oynatmak icin
      // kaldir -> reflow -> --d-base sonra geri ekle.
      el.classList.remove('is-wiped');
      void el.offsetHeight;
      var self = this;
      requestAnimationFrame(function () {
        el.classList.add('is-wiped');
        // Kucuk ink-bleed onayi
        el.classList.add('is-bleeding');
        var ms = toMs(readToken('--d-base'), 420);
        self._stampTimer = setTimeout(function () {
          el.classList.remove('is-bleeding');
        }, ms);
      });
    }
  });
})();
